import {useFavoritesStore} from '~/stores/favorites'

// 啟動時初始化收藏集合(重新整理/直接進站的情境):
// 已登入(cookie 還原 token)→ 抓 API;訪客 → 讀 localStorage。
// 登入/登出當下的切換由 stores/user.ts 的 updateToken 觸發(flushOnLogin / resetToLocal)。
//
// 重要:init() 必須在 hydration 之後(app:mounted)才跑。若在 plugin setup 階段就跑,
// 會在 hydration 前把 store 從 localStorage 填入,使 client 首次 render 與 SSR
// (server 無 localStorage,store 恆空)不一致 → Nuxt hydration mismatch。延到掛載後
// 才載入,hydration 時 store 與 SSR 一致(皆空),掛載後再反映真實收藏。
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:mounted', () => {
        useFavoritesStore().init()
    })
})
